<template>
    <furide-csv-form />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import FurideCsvForm from '@/components/furidecsv/Form.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'furide-csv-form': FurideCsvForm
    }
})
</script>
